import React from "react";
import { PropertyPhotos } from "../../../../global/types";
import {
  Photo,
  MainPhotoWrapper,
  MultiPhotoWrapper,
  Wrapper,
  SmallPhotoWrapper,
  PhotoFilter,
  EmptyPhotoContainer
} from "./styles";

interface IProps {
  photos?: PropertyPhotos[];
  onClick: () => void;
}

function PhotosGrid({ photos = [], onClick }: IProps) {
  const safePhotos = Array.isArray(photos) ? photos : [];

  if (safePhotos.length === 0) {
    return (
      <Wrapper onClick={onClick}>
        <MainPhotoWrapper>
          <EmptyPhotoContainer>
            Sem fotos
          </EmptyPhotoContainer>
        </MainPhotoWrapper>
      </Wrapper>
    );
  }

  const firstPhoto = safePhotos[0];
  const mainPhoto = firstPhoto?.url_l || firstPhoto?.url_m || "";

  const smallPhotos = [];
  for (let i = 1; i < Math.min(5, safePhotos.length); i++) {
    const photo = safePhotos[i];
    if (photo?.url_m) {
      smallPhotos.push({
        url: photo.url_m,
        id: photo.id || `photo-${i}`
      });
    }
  }

  const extraPhotosCount = Math.max(0, safePhotos.length - 5);

  return (
    <Wrapper onClick={onClick}>
      <MainPhotoWrapper>
        {mainPhoto ? (
          <Photo src={mainPhoto} alt="Foto principal do imóvel" loading="eager" />
        ) : (
          <EmptyPhotoContainer>
            Sem imagem
          </EmptyPhotoContainer>
        )}
      </MainPhotoWrapper>

      {smallPhotos.length > 0 && (
        <MultiPhotoWrapper>
          {smallPhotos.map((photo, index) => (
            <SmallPhotoWrapper key={photo.id}>
              {index === smallPhotos.length - 1 && extraPhotosCount > 0 ? (
                <>
                  <PhotoFilter>
                    +{extraPhotosCount}
                  </PhotoFilter>
                  <Photo src={photo.url} alt={`Foto ${index + 2}`} loading="lazy"/>
                </>
              ) : (
                <Photo src={photo.url} alt={`Foto ${index + 2}`} loading="lazy" />
              )}
            </SmallPhotoWrapper>
          ))}
        </MultiPhotoWrapper>
      )}
    </Wrapper>
  );
}

export default PhotosGrid;